module.exports = __webpack_public_path__ + "static/media/aryzta.5c4af805.png";